import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';

export const FiStateResolveContentLanguages = [ContentLanguagesService, FiStateResolveContentLanguagesResolveFunc];

export function FiStateResolveContentLanguagesResolveFunc(contentLanguagesService: ContentLanguagesService) {
    return contentLanguagesService.GetContentLanguages();
}
